import { EpochRequestMsg } from '#websocket/client/proto';
import { EpochRequest, EpochResponse } from './common';
export class ConnectEpochRequest extends EpochRequest {
    constructor(nodeId, clientEpoch, destination) {
        super(EpochRequestMsg.OperationType.CONNECT_EPOCH, nodeId, clientEpoch, undefined, destination);
    }
    createResponse(responseMessage) {
        return new EpochResponse(responseMessage);
    }
}
